import { Component, EventEmitter, Output } from '@angular/core';
import { ProfessionalLogService } from 'components/modal-windows/step-details/log-details/professional-log.service';
import { PAGES } from '../../../log-details/log-details.component';

@Component({
  selector: 'cm-confirm-inv-close',
  templateUrl: './confirm-invitation-close.component.html',
  styleUrls: ['./confirm-invitation-close.component.scss', '../../../step-details.shared.scss'],
})
export class ConfirmInvitationCloseComponent {
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() selectPage: EventEmitter<number> = new EventEmitter();

  constructor(private logService: ProfessionalLogService) {}

  cancelClose() {
    this.selectPage.emit(PAGES.INVITATION);
  }

  closeModal() {
    this.logService.draftSuperviserData = null;
    this.close.emit();
  }
}
